export default __webpack_public_path__ + "static/media/andrea--desktop@2x.77bb8ace.jpg";